/* eslint-disable no-useless-escape */
/**
 * Validates the full password based on Regex pattern rules
 * @param value String containing the password.
 * @returns Returns Boolean value to indicate if the password is correct.
 */
export function passwordValidation(value: string): boolean {
  return (
    passwordLengthValidation(value) &&
    passwordLowerCharValidation(value) &&
    passwordNumberValidation(value) &&
    passwordSpecialCharValidation(value) &&
    passwordUpperCharValidation(value)
  );
}

/**
 * Validates the Length of the password
 * @param value String containing the password.
 * @returns Returns Boolean value to indicate if the password is correct.
 */
export function passwordLengthValidation(value: string): boolean {
  const checkedLength = /^(?=^.{10,}$)/.exec(String(value));
  return checkedLength ? true : false;
}

/**
 * Validates if the string contains lower chars.
 * @param value String containing the password.
 * @returns Returns Boolean value to indicate if the password is correct.
 */
export function passwordLowerCharValidation(value: string): boolean {
  const checkedLowercaseChars = /^(?=.*[a-z])/.exec(String(value));
  return checkedLowercaseChars ? true : false;
}

/**
 * Validates if the string contains upper chars.
 * @param value String containing the password.
 * @returns Returns Boolean value to indicate if the password is correct.
 */
export function passwordUpperCharValidation(value: string): boolean {
  const checkedUppercase = /^(?=.*[A-Z])/.exec(String(value));
  return checkedUppercase ? true : false;
}

/**
 * Validates if the string contains numbers.
 * @param value String containing the password.
 * @returns Returns Boolean value to indicate if the password is correct.
 */
export function passwordNumberValidation(value: string): boolean {
  const checkedNumbers = /^(?=.*\d)/.exec(String(value));
  return checkedNumbers ? true : false;
}

/**
 * Validates if the String contains special characters (@$!%*?&+_:-).
 * @param value String containing the password.
 * @returns Returns Boolean value to indicate if the password is correct.
 */
export function passwordSpecialCharValidation(value: string): boolean {
  const checkedSpecialChars = /^(?=.*[.,@$!%*?&#§+{}<=>@~'";_:\-\(\)])/.exec(
    String(value),
  );
  return checkedSpecialChars ? true : false;
}
